/* eslint-disable camelcase */

class Board {
  constructor(boardName: string) {
    return JSON.parse(JSON.stringify(this.constructor[`_${boardName}`]));
  }
}

export default Board;
